/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { sendSlackNotification } from 'utils/errorReporter';
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const AutomationAPI = {
  automationDataSearch: async(autoParams: any) =>
    (await initAxios('/automations'))
      ?.post(
        'search',
        JSON.stringify({
          autoParams: autoParams,
        }),
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations on automationDataSearch',
        );
        return {
          success: false,
          result: err,
        };
      }),

  getAllAutomations: async() =>
    (await initAxios())
      ?.get('/automations')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations on getAllAutomations',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  searchAutomations: async(query: any) =>
    (await initAxios())
      ?.post('/automations/search', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations/search on searchAutomations',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  countAutomations: async(query: any) =>
    (await initAxios())
      ?.post('/automations/count', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations/count on countAutomations',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getAutomation: async(Automation_id: string) =>
    (await initAxios())
      ?.get(`/automations/${Automation_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations/id on getAutomation',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateAutomation: async(AutomationBody: any) =>
    (await initAxios())
      ?.put('/automations', JSON.stringify(AutomationBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations on updateAutomation',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createAutomation: async(AutomationBody: any) =>
    (await initAxios())
      ?.post('/automations', JSON.stringify(AutomationBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations on createAutomation',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteAutomation: async(Automation_id: string) =>
    (await initAxios())
      ?.delete(`/automations/${Automation_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch(async(err) => {
        await sendSlackNotification(
          'Automations',
          JSON.stringify(err),
          'Failed to call /automations on deleteAutomation',
        );
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default AutomationAPI;
